module.exports = __webpack_public_path__ + "img/guide.b8f58114.svg";